import { log, FACILITY as LOG_FACILITY } from './log';
import { AlignmentConfig } from '../analytics-lib/alignment';
var LOG = LOG_FACILITY.FRAME_CACHE;
export function dataSetLoader2(obj, engine) {
    if (!obj || !obj.frames || !(obj.version === '2.0')) {
        log.error(LOG, 'load called with invalid dataset');
        return false;
    }
    log.info(LOG, '2.0 loader');
    var body = engine.body;
    var frameCache = engine.frameCache;
    var alignmentConfig = new AlignmentConfig();
    if (obj.corrections || obj.frames[obj.timings[0]]) {
        alignmentConfig.qInitials = obj.corrections || obj.frames[obj.timings[0]];
    }
    if (obj.axisTransforms) {
        alignmentConfig.axisTransforms = obj.axisTransforms;
    }
    body.alignment.load(alignmentConfig);
    engine.setMobileAppId(obj.mobileAppId);
    engine.setMovementName(obj.movementName || obj.movementTitle);
    frameCache.captureBegin();
    obj.timings.forEach(function (time) {
        if (obj.frames[time][0][0] === 1) {
            log.warn(LOG, 'discarding frame of identity quaternions');
            return;
        }
        var frame = {
            timestamp: time,
            readings: obj.frames[time],
        };
        engine.pushQuaternions(frame);
    });
    frameCache.captureComplete();
    log.debug(LOG, 'load complete');
    return true;
}
//# sourceMappingURL=dataset-loader-2.js.map